import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TTUserProfile, TTUserProfileUpdate } from '../../interfaces/user';
import { RootState } from '../../rootReducer';
import {
  getCurrentGuestProfile,
  setEmail,
  setUserProfile,
} from '../../features/auth/auth';
import NavBar from '../components/BackButton';
import { message, Spin } from 'antd';
import { LoadingIcon } from '../components/Spinner';
import ViewHeader from '../components/ViewHeader';
import { OrderList } from './OrderList';
import { guestApi } from '../../api/guest';
import {
  EnvelopeIcon,
  PhoneIcon,
  UserCircleIcon,
} from '@heroicons/react/20/solid';
import { GuestSubscriptions } from './Subscriptions';
import { useAppDispatch } from '../../store';

type Props = {};

export function GuestOverview() {
  const guestProfile = useSelector<RootState, TTUserProfile | null>(
    state => state.auth.userProfile,
  );
  const [update, setUpdate] = useState<TTUserProfileUpdate>({});
  const dispatch = useAppDispatch();
  const [fetching, setFetching] = useState(false);
  useEffect(() => {
    dispatch(getCurrentGuestProfile());
  }, []);

  const updateProfile = async () => {
    try {
      setFetching(true);
      const response = await guestApi.updateGuest(update, guestProfile?.id);
      dispatch(setUserProfile(response.data));
      setFetching(false);
    } catch (e) {
      setFetching(false);
      message.error(
        e?.response?.data?.detail[0]?.msg ??
          e?.response?.data?.detail ??
          'Unable to update',
      );
    }
  };

  return (
    <>
      <div className="overflow-y-auto scrolling-touch min-h-screen bg-surface pb-32">
        <NavBar show_refresh={false} hide={true} />
        <div className="flex justify-between items-center mt-4 md:px-32">
          <ViewHeader title={`Guest Profile`} className={'text-left px-4'} />
        </div>

        <div className=" mt-4 px-4 md:px-32">
          <div
            key={guestProfile?.id?.toString()}
            className="relative flex px-2 py-2 items-center space-x-3 rounded-lg border border-outline bg-secondary-container  shadow-sm "
          >
            <Spin
              spinning={fetching}
              indicator={LoadingIcon}
              size={'large'}
              tip="Saving..."
              className="w-full"
              wrapperClassName="w-full"
            >
              <div className="w-full">
                <div className="focus:outline-none">
                  <div className="flex-col space-x-1 items-center">
                    <div className="relative mt-1 rounded-md shadow-sm">
                      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <UserCircleIcon className="h-4 w-4 text-primary" />
                      </div>
                      <div className="mt-1">
                        <input
                          type="text"
                          name="name"
                          id="name"
                          defaultValue={guestProfile?.first_name}
                          value={update?.first_name ?? guestProfile?.first_name}
                          onChange={e => {
                            setUpdate({
                              ...update,
                              first_name: e.target.value,
                            });
                          }}
                          className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline rounded-md placeholder-on-surface-variant/60 focus:ring-primary/70 focus:border-primary text-on-surface-variant transition duration-150 ease-in-out text-md sm:leading-5 pl-10"
                          placeholder={guestProfile?.first_name}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex-col space-x-1 items-center">
                    <div className="relative mt-1 rounded-md shadow-sm">
                      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <PhoneIcon className="h-4 w-4 text-primary" />
                      </div>
                      <div className="mt-1">
                        <input
                          type="tel"
                          name="phone"
                          id="phone"
                          defaultValue={guestProfile?.phone_number}
                          disabled
                          value={guestProfile?.phone_number}
                          className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline rounded-md placeholder-on-surface-variant/60 focus:ring-primary/70 focus:border-primary text-on-surface-variant transition duration-150 ease-in-out text-md sm:leading-5 pl-10 cursor-not-allowed disabled:bg-surface/70"
                          placeholder={guestProfile?.phone_number}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex-col items-center space-x-1">
                    <div className="relative mt-1 rounded-md shadow-sm">
                      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <EnvelopeIcon className="w-4 h-4 text-primary" />
                      </div>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        onChange={e => {
                          const re = /\S+@\S+\.\S+/;
                          setUpdate({ ...update, email: e.target.value });
                        }}
                        className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline rounded-md placeholder-on-surface-variant/60 focus:ring-primary/70 focus:border-primary text-on-surface-variant transition duration-150 ease-in-out text-md sm:leading-5 pl-10"
                        placeholder="you@example.com"
                        value={update?.email ?? guestProfile?.email}
                      />
                    </div>
                  </div>
                  <button
                    type="button"
                    className="mt-2 bg-primary  rounded-md w-full px-2 py-2 text-on-primary font-semibold"
                    // disabled={Object.keys(update)?.length === 0}
                    onClick={async () => {
                      console.log('clciking...');
                      await updateProfile();
                    }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </Spin>
          </div>
          {guestProfile !== null && <GuestSubscriptions />}
          {guestProfile !== null && <OrderList />}
        </div>
      </div>
    </>
  );
}
